// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__jyV95","imageUploader":"EGiftCard_imageUploader__2Mp9j"};